import PricingHeader from "../../components/Layouts/PricingHeader";
import Header from "../../components/Layouts/Header";
import NewsRoomPage from "../../components/Newsroom/NewsRoom";
import BottomBar from "../../components/Layouts/BottomBar";
import PricingFooter from "../../components/Layouts/PricingFooter";
import "./Newsroom.css";
const NewsRoom = () => {
  return (
    <>
      <div className="newsroom_page">
        <Header />
        <NewsRoomPage />
        <BottomBar className="bottom-bar-spacing" />
        <PricingFooter />
      </div>
    </>
  );
};

export default NewsRoom;
